const TARGET = 'sus_issues';

const initialState = {
  error: null,
  data: null,
};

const reducer = (state = initialState, action) => {
  switch(action.type) {
    case 'API_CALL_REQUEST':
      if (action.target !== TARGET) return state;
      return {
        ...state,
        fetching: action.method === 'GET',
      };
    case 'API_CALL_COMPLETE':
      const { response } = action;
      if(!response || response.target !== TARGET) return state;
      return {
        ...state,
        data: response.result,
        fetching: false,
      };
    case 'API_CALL_FAILED':
      if(!action.request || action.request.target !== TARGET) return state;
      return {
        ...state,
        error: action.code,
        fetching: false,
      };
    default:
      return state;
  }
};

export {
  reducer as sus_issues,
};
